export function getStoreSlug() {
  return window.location.pathname.split('/')[1].toLowerCase();
}

// export default new StoreUtil();
